module.exports = __webpack_public_path__ + "img/apdcl_logo.b56b6858.png";